import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import useLocalStorage from "src/hooks/useLocalstorage";

export const GetUserProfileContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GetUserProfileProvider: FunctionComponent<Props> = ({ children }) => {
  const [accessKey, _] = useLocalStorage("clu", {});
  const [, setUserName] = useLocalStorage("cld", {});

  const { data, isFetching, isLoading, error, refetch } = useQuery({
    queryKey: ["user_profile"],
    enabled: !!accessKey,
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`account/profile`);

      const get_firstname = data && data.user.first_name;
      const get_lastname = data && data.user.last_name;
      const get_email = data && data.user.email;
      const get_profile_picture = data && data.user.image;
      const get_business_name = data && data.organisation.name;

      setUserName({
        firstname: get_firstname,
        lastname: get_lastname,
        email: get_email,
        p_p: get_profile_picture,
        businessName: get_business_name,
      });

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
      refetch,
    }),
    [isLoading, data, error, isFetching, refetch],
  );
  return (
    <GetUserProfileContext.Provider value={contextValue}>
      {children}
    </GetUserProfileContext.Provider>
  );
};

export default GetUserProfileProvider;
